import React, { useRef, useState } from 'react';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import QRCode from '@bitcoin-portal/bitcoincom-pkg-components/dist/QRCode';
import {
  QrCodeModalWrapper,
  QrCodeWrapper,
  ModalCTA,
  StyledTitle,
  StyledSubtitle,
  QrImage,
  ModalWrapper,
} from './styled';
import StoreToggle from './StoreToggle';

type Store = 'GOOGLE_PLAY' | 'APP_STORE';

const QrCodeModal: React.FC = () => {
  const modalRef = useRef<{ open: () => void }>(null);
  const [selectedStore, setSelectedStore] = useState<Store>('GOOGLE_PLAY');

  const qrValue =
    selectedStore === 'GOOGLE_PLAY'
      ? 'https://play.google.com/store/apps/details?id=com.bitcoin.mwallet&pli=1'
      : 'https://apps.apple.com/us/app/bitcoin-com-wallet-buy-sell/id1252903728?ls=1';

  return (
    <QrCodeModalWrapper>
      <ModalCTA
        className="ga-wallet-cta get-app-cta-button"
        onClick={() => modalRef.current?.open()}
      >
        <QrImage src="/images/uploads/scanner.png" alt="QR image" />
      </ModalCTA>
      <ModalWrapper>
        <Modal ref={modalRef}>
          <StyledTitle>Install the Bitcoin.com Wallet</StyledTitle>
          <StyledSubtitle>
            Scan this QR code with your device’s camera, then follow the
            instructions to download the app.
          </StyledSubtitle>
          <StoreToggle
            selectedStore={selectedStore}
            setSelectedStore={setSelectedStore}
          />
          <QrCodeWrapper>
            <QRCode value={qrValue} />
          </QrCodeWrapper>
        </Modal>
      </ModalWrapper>
    </QrCodeModalWrapper>
  );
};

export default QrCodeModal;
